module.exports = __webpack_public_path__ + "static/img/logo-white.19597bb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-white.svg
// module id = zv6/
// module chunks = 1